import React from "react";
import { Bet } from "../../types/Bet";
import { Match } from "../../types/Match";
import FixtureTile from "../components/FixtureTile/FixtureTile";
import FixturesPlaceholder from "./FixturesPlaceholder";
import "./FixtureStyles.scss";

interface FixtureBodyProps {
  currentFixtures: Match[];
  bets: Bet[];
  setCurrentModalMatch: React.Dispatch<React.SetStateAction<Match>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDesktop?: boolean;
}

const FixtureBody: React.FC<FixtureBodyProps> = ({
  currentFixtures,
  bets,
  setCurrentModalMatch,
  setIsOpen,
  isDesktop
}) => {
  if (currentFixtures.length === 0) {
    return <FixturesPlaceholder message="No matches scheduled for this day." />;
  }

  return (
    <div className="fixtureBody__root">
      {currentFixtures.map((match) => (
        <div
          key={`fixture-${match.id}`}
          className="fixtureBody__item"
        >
          <FixtureTile
            match={match}
            bet={bets.filter(bet => bet.matchId === match.id)}
            setCurrentModalMatch={setCurrentModalMatch}
            setIsOpen={setIsOpen}
            isDesktop={isDesktop}
          />
        </div>
      ))}
    </div>
  );
};

export default FixtureBody;